import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { MyThunkDispatch, RootState } from 'store';

import { getCompanyBilling } from 'actions/companyBilling';
//import { fetchNationalityCountryList } from 'actions/i18n';
import useSelectionOrigin from 'hooks/useSelectionOrigin';
import useToast from 'hooks/useToast';
import { BillingCompany } from 'models/billingCompany';
import BillingCompanyForm from 'screens/components/BillingCompany';
import { saveBillingCompany } from 'services/billingCompanyService';

interface Params {
  match: {
    params: {
      billingCompanyId: string;
    };
  };
  originRule?: string;
  isFromSelection?: boolean;
  onCloseFormCostCenter?: () => void;
}

const BillingCompanyFormContainer = ({
  match: { params },
  onCloseFormCostCenter,
  isFromSelection,
  originRule,
}: Params) => {
  const toast = useToast();
  const dispatch: MyThunkDispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(!!params.billingCompanyId);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [billingCompany, setBillingCompany] = useState<BillingCompany>();
  const fromOrigin = useSelectionOrigin();

  const { accountResult } = useSelector((state: RootState) => state.user);
  if (!accountResult) return null;
  const { companyId, countryCurrency } = accountResult;

  /*const {
    i18n: { loadingNationalityCountries, nationalityCountries },
  } = useSelector((state: RootState) => state);*/

  const loadBillingCompany = useCallback(async () => {
    try {
      if (params.billingCompanyId && isLoading) {
        const data = await dispatch(getCompanyBilling(companyId));

        const billingCompany_Company = data?.billingCompanies?.find((b) => b.id === params.billingCompanyId);

        if (billingCompany_Company) {
          setBillingCompany({
            companyId: billingCompany_Company.id,
            legalName: billingCompany_Company.legalName,
            corporateName: billingCompany_Company.corporateName,
            document: billingCompany_Company.document,
            email: billingCompany_Company.email,
            countryId: billingCompany_Company.countryId,
            onboardingDone: billingCompany_Company.onboardingDone,
            bookingAllowed: billingCompany_Company.bookingAllowed,
            optimisticPayments: billingCompany_Company.optimisticPayments,
            lineOfCreditAvailable: billingCompany_Company.lineOfCreditAvailable,
            contactName: billingCompany_Company.contactName,
            contactLastName: billingCompany_Company.contactLastName,
            contactPhoneNumber: billingCompany_Company.contactPhoneNumber,
            contactEmail: billingCompany_Company.contactEmail,
            contactDocumentNumber: billingCompany_Company.contactDocumentNumber,
            contactBillingEmail: billingCompany_Company.contactBillingEmail,
            billingCompanyAddress: billingCompany_Company.billingCompanyAddress,
            billingCompanyAddressNumber: billingCompany_Company.billingCompanyAddressNumber,
            billingCompanyAddressCity: billingCompany_Company.billingCompanyAddressCity,
            billingCompanyAddressCountry: billingCompany_Company.billingCompanyAddressCountry,
            billingCompanyAddressPostalCode: billingCompany_Company.billingCompanyAddressPostalCode,
          } as BillingCompany);
        } else {
          throw 'Empresa Cliente no fue encontrada';
        }
      }
    } catch (error) {
      toast.add({ type: 'danger', message: 'Error' });
    } finally {
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, params.billingCompanyId, toast]);

  useEffect(() => {
    loadBillingCompany();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSaveBillingCompany = async (billingCompany: BillingCompany) => {
    setIsSubmitting(true);
    try {
      const lineOfCreditAvailable = billingCompany.lineOfCreditAvailable;
      let companyCreditCardByUser:any = '';

      if(!lineOfCreditAvailable){
        companyCreditCardByUser = billingCompany.companyCreditCardByUser;
      }

      const data = await saveBillingCompany(
        {
          ...billingCompany,
          lineOfCreditAvailable:lineOfCreditAvailable,
          companyCreditCardByUser:companyCreditCardByUser
        },
        companyId,
      );

      setIsSubmitting(false);
      if (isFromSelection) {
        fromOrigin.updateItemCreated([data]);
        return;
      }
    } catch (e) {
      setIsSubmitting(false);
      throw e;
    }
  };

  /*const data = {
    nationalityCountries,
    loadingNationalityCountries,
  };*/

  return (
    <BillingCompanyForm
      isFromSelection={isFromSelection}
      loading={isLoading}
      submitting={isSubmitting}
      billingCompany={billingCompany}
      //countryCurrency={countryCurrency}
      onConfirm={handleSaveBillingCompany}
      onCloseFormCostCenter={onCloseFormCostCenter}
      //fetchCountryList={() => dispatch(fetchNationalityCountryList())}
      //loadingNationalityCountries={data.loadingNationalityCountries}
      //nationalityCountries={data.nationalityCountries}
    />
  );
};

export default BillingCompanyFormContainer;
